import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

import { integrationSelector } from 'common/selectors';
import { isIframe } from 'integration/integration.utils';

export function SkipToContent({ hasVideoListArea = false }) {
  const integration = useSelector(integrationSelector);
  const { t } = useTranslation();

  const handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      document.getElementById('ct-page').focus();
    }
  };

  return (
    <div className="ct-skip-to-content" onKeyDown={handleKeyDown}>
      <p>{t('skip-to')}</p>
      <ol className="ct-skip-to-content__list">
        <li className="ct-skip-to-content__item">
          <Link to="#page-navigation">{t('skip-to-navigation')}</Link>
        </li>
        <li className="ct-skip-to-content__item">
          <Link to="#page-content">{t('skip-to-content')}</Link>
        </li>
        {hasVideoListArea && (
          <li className="ct-skip-to-content__item">
            <Link to="#page-video-lists">{t('skip-to-video-lists')}</Link>
          </li>
        )}
        {!isIframe(integration) && (
          <li className="ct-skip-to-content__item">
            <Link to="#page-footer">{t('skip-to-footer')}</Link>
          </li>
        )}
      </ol>
    </div>
  );
}
